import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "row"]

  add() {
    const template = this.templateTarget
    const clone = template.content.cloneNode(true)
    template.parentNode.insertBefore(clone, template)
  }
}
